export default __webpack_public_path__ + "static/media/img5.d89a9a04.png";